import {
  HttpHandler, HttpInterceptor, HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpCacheService } from './http-cache.service';


@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor(
  private cacheService: HttpCacheService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {


    //check if the outgoing calls are GET and MRDH APIs
    const skipCache = req.headers.keys().some((x) => x === 'skip-cache');
    if (req.method === 'GET' && !skipCache) {
      // attempt to retrieve a cached response
      const cachedResponse:
        | HttpResponse<any>
        | undefined = this.cacheService.get(req.urlWithParams);

      // return cached response
      if (cachedResponse) {
        return of(cachedResponse);
      }

      // send request to server and add response to cache
      return next.handle(req).pipe(
        tap((event) => {
          if (event instanceof HttpResponse) {
            // console.log(`Adding item to cache: ${req.urlWithParams}`);
            this.cacheService.put(req.urlWithParams, event);
          }
        })
      );
    }
    else {
        // pass along non-cacheable requests
        return next.handle(req);
    }
  }
}
